export function slugify(text) {
  return String(text ?? '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
}

export function normalizeSlug(slug) {
  return String(slug ?? '').trim().replace(/^\//, '')
}

/** Slug de ruta: `{titulo-slug}-{id}` (único aunque el título se repita). */
export function getCasoSlug(caso) {
  const titleSlug = slugify(caso?.title)
  const id = String(caso?.id ?? '').trim()
  if (!titleSlug && !id) return ''
  if (!id) return titleSlug
  return `${titleSlug}-${id}`
}

export function findCasoBySlug(casos, slug) {
  const normalized = normalizeSlug(slug)
  if (!normalized) return null
  return (casos ?? []).find((caso) => getCasoSlug(caso) === normalized) ?? null
}
